//any type checked blueice
import { TranslatableString } from '../shared/model/translateble-string.model';

export interface IDiscount {
    id?: string;
    description?: string;
    code?: string;
    active?: boolean;
    translateDescription?: TranslatableString[];
    priority?: number;
}

export class Discount implements IDiscount {
    constructor(
        public id?: string,
        public description?: string,
        public code?: string,
        public active?: boolean,
        public translateDescription?: TranslatableString[],
        public priority?: number
    ) {
        this.id = id ? id : null;
        this.description = description ? description : '';
        this.code = code ? code : '';
        this.active = active ? active : true;
        this.translateDescription = translateDescription ? translateDescription : [];
        this.priority = priority ? priority : 0;
    }
}
